export default __webpack_public_path__ + "static/media/revealed.282cd249.mp3";